import React from "react";
import "./footer.css"

function Footer() {
   
    return (
<div className="footer">

<p  id="not-dark" className="Copy text-center">2021 © Copyright <strong>Laura Cejas</strong>. All Rights Reserved</p>

       
</div>
    )    
}

export default Footer;